import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initOrganizationSliders = () => {
  const slidersContainer = document.querySelector("[data-organization-sliders]");
  if (!slidersContainer) return;

  const organizationSliders = slidersContainer.querySelectorAll("[data-organization-slider]");

  organizationSliders.forEach(slider => {
    new Swiper(slider, {
      lazy: true,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        type: "fraction",
      },
      navigation: {
        nextEl: slider.querySelector(".slider-navigation__button--next"),
        prevEl: slider.querySelector(".slider-navigation__button--prev"),
      },
    });
  })
};

export default initOrganizationSliders;
